import { buildQuery, requestJson } from "./apiClient";

export function listClientViews(params = {}) {
  return requestJson(`/api/admin/client-views${buildQuery(params)}`);
}

export function getClientView(clientViewId, params = {}) {
  return requestJson(`/api/admin/client-views/${clientViewId}${buildQuery(params)}`);
}

export function createClientView(payload) {
  return requestJson("/api/admin/client-views", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateClientView(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export function archiveClientView(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}`, {
    method: "DELETE",
  });
}

export function ensureClientViewDraft(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/draft/ensure`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function saveClientViewDraftManifest(clientViewId, manifest) {
  return requestJson(`/api/admin/client-views/${clientViewId}/draft/manifest`, {
    method: "PUT",
    body: JSON.stringify({ manifest }),
  });
}

export function validateClientViewDraftManifest(clientViewId, manifest) {
  return requestJson(`/api/admin/client-views/${clientViewId}/draft/validate`, {
    method: "POST",
    body: JSON.stringify({ manifest }),
  });
}

export function publishClientViewDraft(clientViewId, changeSummary) {
  return requestJson(`/api/admin/client-views/${clientViewId}/publish`, {
    method: "POST",
    body: JSON.stringify({ changeSummary }),
  });
}

export function clonePublishedClientViewDraft(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/draft/clone-from-published`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listClientViewVersions(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/versions`);
}

export function getClientViewDraftPreview(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/preview/manifest`);
}

export function getClientViewStudio(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/studio`);
}

export function getClientViewManifestDiff(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/diff`);
}

export function createClientViewPreviewToken(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/preview-token`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function cloneClientView(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/clone`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function restoreClientViewVersionToDraft(clientViewId, versionId) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/versions/${versionId}/restore-to-draft`,
    { method: "POST", body: JSON.stringify({}) }
  );
}

export function getClientViewAnalytics(clientViewId, params = {}) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/analytics${buildQuery(params)}`
  );
}

export function listClientViewWebhooks(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/webhooks`);
}

export function createClientViewWebhook(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/webhooks`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateClientViewWebhook(clientViewId, webhookId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/webhooks/${webhookId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function rotateClientViewWebhookSecret(clientViewId, webhookId) {
  return updateClientViewWebhook(clientViewId, webhookId, { rotateSecret: true });
}

export function sendClientViewWebhookTest(clientViewId, webhookId) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/webhooks/${webhookId}/test`,
    {
      method: "POST",
      body: JSON.stringify({}),
    }
  );
}

export function previewClientViewDataset(clientViewId, dataSourceId) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/datasets/${encodeURIComponent(dataSourceId)}/preview`,
    { method: "POST", body: JSON.stringify({}) }
  );
}

export function listClientViewPublicUsers(clientViewId, params = {}) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/public-users${buildQuery(params)}`
  );
}

export function getExternalApiAccess(clientViewId) {
  return requestJson(`/api/admin/client-views/${clientViewId}/external-api`);
}

export function createExternalApp(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/external-apps`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateExternalApp(clientViewId, externalAppId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/external-apps/${externalAppId}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function createExternalApiKey(clientViewId, payload) {
  return requestJson(`/api/admin/client-views/${clientViewId}/external-api-keys`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function rotateExternalApiKey(clientViewId, apiKeyId) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/external-api-keys/${apiKeyId}/rotate`,
    { method: "POST", body: JSON.stringify({}) }
  );
}

export function revokeExternalApiKey(clientViewId, apiKeyId) {
  return requestJson(
    `/api/admin/client-views/${clientViewId}/external-api-keys/${apiKeyId}/revoke`,
    { method: "POST", body: JSON.stringify({}) }
  );
}
